var map = {
	"./anotador-de-truco-uruguayo.json": 4314,
	"./beneficios-de-los-juegos-de-puzzles-para-la-salud-mental.json": 7451,
	"./historia-del-truco-uruguayo.json": 6599,
	"./letras-fugitivas.json": 2874,
	"./paradojas-de-zenon.json": 4230,
	"./por-que-el-truco-se-juega-con-la-baraja-espanola.json": 5050,
	"./que-frases-se-usan-en-el-truco-uruguayo.json": 5511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7158;